import type {
  FloorDM,
  FloorLayout,
  // @ts-expect-error
  ShopFloorDepartmentDM,
} from './FloorModels';

export type MapLayout = FloorLayout;

export type FloorVM = FloorDM;
export const getFloorVM = (floorDM: FloorDM): FloorVM => floorDM;

/** Shop Floor layout */
export type MapShopLayoutDepartmentPosition =
  | 'bottom'
  | 'bottomLeft'
  | 'bottomRight'
  | 'center'
  | 'extra'
  | 'left'
  | 'right'
  | 'top'
  | 'topLeft'
  | 'topRight';

export type MapShopLayoutDepartmentCss = {
  top: number | string;
  left: number | string;
  width: number | string;
  height: number | string;
  backgroundColor?: string;
  borderColor?: string;
  borderWidth?: number;
};
export type MapShopLayoutDepartmentVM = {
  position: MapShopLayoutDepartmentPosition;
  title: string;
  id: ShopFloorDepartmentDM['departmentId'];
  ui: MapShopLayoutDepartmentCss;
};

export type Department = {
  blockCoordinates: number[];
  departmentId: number;
};

export type MapGrid = (number | undefined)[][];
export type Border = 'bottom' | 'left' | 'right' | 'top';
export type Notch = 'bl' | 'br' | 'tl' | 'tr';
